import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { FlexColumn, FlexRow } from '../styles/Containers'
import RedactionFileRow from './RedactionFileRow'
import InlineFilePreview from './InlineFilePreview'
import useInlineFilePreview from '../../hooks/useInlineFilePreview'

const Rows = styled(FlexColumn)`
  min-width: 420px;
  flex: 1 1 480px;
`

const Split = styled(FlexRow)`
  flex-wrap: wrap;
  align-items: flex-start;
`

// Redaction files and their shared in-tab preview.
function RedactionFileList({
  files,
  foiId,
  preview = null,
  loading = false,
  viewOnly = false,
  onPreviewConsumed,
  handleReplaceFile = () => {},
  handleRenameFile = () => {}
}) {
  const rows = files ?? []
  const filePreview = useInlineFilePreview({ files, preview, onPreviewConsumed })

  return (
    <Split gap="15px">
      <Rows gap="10px">
        {rows.map(f => (
          <RedactionFileRow
            file={f}
            foiId={foiId}
            loading={loading}
            viewOnly={viewOnly}
            key={f.id}
            active={f.id === filePreview.activeFile?.id}
            onPreview={file => filePreview.openFile(file)}
            handleReplaceFile={handleReplaceFile}
            handleRenameFile={handleRenameFile}
          />
        ))}
      </Rows>
      <InlineFilePreview preview={filePreview} />
    </Split>
  )
}

RedactionFileList.propTypes = {
  files: PropTypes.array,
  foiId: PropTypes.string.isRequired,
  preview: PropTypes.shape({
    fileId: PropTypes.string.isRequired,
    filename: PropTypes.string,
    page: PropTypes.number,
    nonce: PropTypes.number
  }),
  loading: PropTypes.bool,
  viewOnly: PropTypes.bool,
  onPreviewConsumed: PropTypes.func,
  handleReplaceFile: PropTypes.func,
  handleRenameFile: PropTypes.func
}

export default RedactionFileList
